<script lang="ts">
    /**
     * Consistent page header used on list pages (heroes, tier-list, maps).
     * Renders the "Overwatch {highlight}" title badge and optional subtitle.
     */
    let { highlight, subtitle }: { highlight: string; subtitle?: string } = $props();
</script>

<h1 class="font-display mx-3 mt-4 self-center text-center text-4xl font-bold text-base-content">
    Overwatch <span class="text-primary">{highlight}</span>
</h1>
{#if subtitle}
    <p class="mx-3 mt-1 text-center text-base text-base-content/60">{subtitle}</p>
{/if}
